module.exports = __webpack_public_path__ + "static/media/emina_brand_banner.fe2aecf1.png";